import React from 'react';
import { XIcon } from 'lucide-react';
import { PAIN_POINTS } from '../data/content';
export function PainSection() {
  return <section className="bg-deep py-14" data-id="element-122" data-mp="38wlueu6m0ui9">
      <div className="mx-auto max-w-page px-5" data-id="element-123" data-mp="38vkg8guarrwb">
        <h2 className="font-display text-[30px] font-black leading-[1.08] text-canvas sm:text-[40px]" data-id="element-124" data-mp="2ux41c2ma6v33">
          ¿Cuántas veces más vas a llegar al viernes{' '}
          <span className="italic text-amber" data-id="element-125" data-mp="2l8c9duh80as6">sin energía para nada?</span>
        </h2>

        <p className="mt-5 border-l-2 border-flame pl-4 font-display text-[19px] font-bold italic leading-snug text-canvas/90 sm:text-[22px]" data-id="element-126" data-mp="2l6j2qf6lxqk6">
          No te falta disciplina. Te falta que alguien te arme el plan por vos.
        </p>

        <ul className="mt-8 flex flex-col gap-2.5" data-id="element-127" data-mp="2g8hn648e49dg">
          {PAIN_POINTS.map(point => <li key={point} className="flex items-start gap-3 rounded-xl bg-white/[0.06] px-4 py-3.5" data-id="element-128" data-mp="229qc6qotr3tj">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-flame/20" data-id="element-129" data-mp="278b9ah8s57dr">
                <XIcon className="h-3.5 w-3.5 text-flame" aria-hidden="true" data-id="element-130" data-mp="3rm98l2w66cum" />
              </span>
              <span className="text-[14.5px] leading-snug text-canvas/85" data-id="element-131" data-mp="3nm74yo6vj9cp">{point}</span>
            </li>)}
        </ul>

        <p className="mt-9 text-center font-display text-[24px] font-black leading-tight text-amber sm:text-[30px]" data-id="element-132" data-mp="5ehrj1m70dt0">
          ¿Y si esta fuera la última semana que pasás así?
        </p>
      </div>
    </section>;
}